import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./components/containers/ErrorBoundary";
import TheContainer from "./components/containers/TheContainer";
import store from "./store";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/vi";
import { useEffect } from "react";

const App = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  console.log(i18n.language, 'i18n.languagei18n.language')

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <TheContainer />
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
